import React, { lazy, Suspense, useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import "../ContactUs/Contactus.css";
import { Container, Row, Button, Col } from "react-bootstrap";
import content from '../content.json';
import parse from 'html-react-parser';
import Error from '../error/ErrorPage';
import Header from "../Header/index";
import Body from "../Body/Body";
import Contactus from "../ContactUs/Contactus";
import ReadyToChase from '../Unwrap/unwrap';
import Footer from '../FooterNew/index';
import axios from "axios";

function LOPage() {

  const [dataJson, setDataJson] = useState(null); // Set initial state as null
  const [loInfo, setLoInfo] = useState(null); // Initialize loInfo as null
  const [loanOfficerUid, setLoanOfficerUid] = useState('');
  const { loName } = useParams();
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { agentName } = useParams();
  const agentJsonName = agentName + ".json";
  const [loading, setLoading] = useState(true);
  const [loadBodyData, setLoadBodyData] = useState(true);
  const [agentData, setAgentData] = useState();
  const [loanOfficerActive, setLoanOfficerActive] = useState(true);
  const [loanOfficerData, setLoanOfficerData] = useState();
  const [realorData, setRealtorData] = useState();
  const [aiBrandingData, setAiBrandingData] = useState();
  const [angelAiUserInfo, setAngelAiUserInfo] = useState();
  const [data, setData] = useState(null); // Set initial state as null


  useEffect(() => {
    const fetchData = async () => {
      try {
        // const timestamp = Date.now();
        // const response = await fetch(`${process.env.REACT_APP_VASTREAMLINE_PROGRAM_JSON}?timestamp=${timestamp}`);
        // const jsonData = await response.json();
        setDataJson(content);
      } catch (error) {
        console.error('Error fetching links:', error);
        setDataJson(content); // Use local JSON data if fetching fails
      }
    };

    if (!dataJson) {
      fetchData(); // Fetch JSON only if the links data is not available
    }
  }, [dataJson]);

  useEffect(() => {
    if (!dataJson) {
      setDataJson(content); // Set local JSON data as fallback initially
    }
  }, []);


  useEffect(() => {
    
    const fetchAiBrandingJson = async () => {
      try {
        await axios
          .get(process.env.REACT_APP_ANGELAI_JSON)
          .then((response) => {
            // console.log(JSON.stringify(response.data));
            setAiBrandingData(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    };

    /**
     * Fetches the Angel AI user info from the specified endpoint.
     *
     * @return {Promise<void>} - A Promise that resolves when the user info has been fetched successfully.
     */
    const fetchAngelAiUserInfo = async () => {
      try {
        await axios
          .get(process.env.REACT_APP_ANGEL_AI_WEB_USER_INFO)
          .then((response) => {
            // console.log(JSON.stringify(response.data));
            setAngelAiUserInfo(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    };

    /**
     * Checks if a loan officer is active.
     *
     * @param {string} loanOfficerId - The ID of the loan officer.
     * @return {Promise<void>} A promise that resolves when the function completes.
     */
    const checkifLoanOfficerIsActive = async (loanOfficerId) => {
      try {
        await axios
          .post(process.env.REACT_APP_CHECK_LO_ACTIVE, {
            loanOfficerId: loanOfficerId,
          })
          .then((response) => {
            // console.log(JSON.stringify(response.data));
            setLoanOfficerActive(response.data.active);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    };

    
    const fetchAgentDetails = async () => {
      try {
        await axios
          .get(
            process.env.REACT_APP_CDN +
            "mlo-product-guidelines/jsons/" +
            agentJsonName
          )
          .then(async (response) => {
            // console.log(JSON.stringify(response.data));
            const responseData = response.data;
            setAgentData(responseData);
            await fetchAiBrandingJson();
            if (responseData) {
              setLoading(false);
              const loanOfficerId = responseData.staff.loanOfficer.ssid;
              await checkifLoanOfficerIsActive(loanOfficerId);
              await fetchAngelAiUserInfo();
              setLoanOfficerData(responseData.staff.loanOfficer);
              setRealtorData(responseData.staff.realtor);
              setLoadBodyData(false);
            }
          })
          .catch((error) => {
            window.location.replace("https://www.swmc.com");
          });
      } catch (e) {
        console.log(e);
      }
    };

    fetchAgentDetails();
  }, []);

  return (
    <div>
      {dataJson ? (
        <>
          <Header fetchpriority="high" />
          <Body fetchpriority="high" dataJson={dataJson.body} />
          <Suspense fallback={<div />}>
            <ReadyToChase dataJson={dataJson.unwrap}
              realtorData={realorData}
              loanOfficerActive={loanOfficerActive}
              loanOfficerData={loanOfficerData}
              angelAiUserInfo={angelAiUserInfo}
            />
          </Suspense>

          <Suspense fallback={<div />}>
            <Footer />
          </Suspense>
        </>
      ) : (
        <div className='loading'>Loading...</div>
      )}

    </div>
  );
}

export default LOPage;
